module.exports = __webpack_public_path__ + "img/Group 2085660338.c274e71c.png";